import { TextElementDto } from "@repo/api/overlays";

import { getHexWithOpacity } from "../../utils/color.ts";
import { useFont } from "../../utils/font.ts";
import { getTextLayoutStyle } from "../../utils/text-layout.ts";

type Props = {
  element: TextElementDto;
  fontSize?: number;
  text?: string;
};

export default function TextElement({ element, fontSize, text }: Props) {
  const fontFamily = useFont({
    fontExternalId: element.typography.fontExternalId,
    fontWeight: element.typography.fontWeight,
    fontStyle: element.typography.fontStyle,
  });
  const textColor = getHexWithOpacity(
    element.color.color,
    element.color.opacity ?? element.opacity ?? 100,
  );

  if (fontFamily === null) {
    return null;
  }

  return (
    <div
      style={{
        ...getTextLayoutStyle(
          {
            ...element.typography,
            fontSize: fontSize ?? element.typography.fontSize,
          },
          fontFamily,
        ),
        color: textColor,
      }}
    >
      {text ?? element.text}
    </div>
  );
}
